import ManagerComment from "./components/managerComment";

export default ManagerComment;